import { Link } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { HeroContentDto } from '../application/dto/HeroContentDto';
import './Hero.css';

export interface HeroProps {
  content: HeroContentDto;
}

/**
 * Pure presentational component per Clean Architecture rules — receives
 * already-validated content as props, contains no business logic, no
 * fetching, no fallback/default copy of its own.
 */
export function Hero({ content }: HeroProps) {
  const isExternalCta = /^https?:\/\//.test(content.ctaHref);

  return (
    <section className="dma-hero" aria-labelledby="dma-hero-heading">
      <Container>
        <div className="dma-hero__inner">
          <h1 id="dma-hero-heading" className="dma-hero__headline">
            {content.headline}
          </h1>
          {content.subheadline ? <p className="dma-hero__subheadline">{content.subheadline}</p> : null}
          {isExternalCta ? (
            <a className="dma-hero__cta" href={content.ctaHref}>
              {content.ctaLabel}
            </a>
          ) : (
            <Link className="dma-hero__cta" to={content.ctaHref}>
              {content.ctaLabel}
            </Link>
          )}
        </div>
      </Container>
    </section>
  );
}
